// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"1510":"bb6a533b08b9e5b8","2759":"211207d48a688222","8083":"77dc7c8d4325540c","8809":"20ee01af1b3afb5d","9383":"592f658f37450aec"}[chunkId] + ".js";
};